import React from "react";
import Dialog from "@mui/material/Dialog";
import { RxCross2 } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import useSendEvent from "hooks/useSendEvent";

export default function Promo({ open, setOpen, banner }) {
  const { sendEvent } = useSendEvent();
  const navigate = useNavigate();

  const handleNavigate = () => {
    sendEvent("promo_image", "promo");
    navigate("/allcourses");
    setOpen(false);
  };

  return (
    <Dialog
      onClose={() => setOpen(false)}
      aria-labelledby="customized-dialog-title"
      open={open}
      PaperProps={{
        sx: {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
    >
      <div className="relative w-full h-full">
        <RxCross2
          className="absolute top-0 right-0 text-3xl text-white cursor-pointer"
          onClick={() => setOpen(false)}
        />
        <div onClick={handleNavigate} className="cursor-pointer">
          <img
            src={banner?.promo_image}
            alt="promo-banner"
            className="w-full h-auto"
          />
        </div>
      </div>
    </Dialog>
  );
}
